"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cspKeys = void 0;
var cspKeys = exports.cspKeys = {
  dev: '37ca2446b1c4590486d8401bbdb8e4b0',
  test: 'a156155642b857889a085c7f10e7319f',
  prod: 'a9d8359a625457b7809759211fabf76b'
};